import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/jobStatusOptions'
import Component from 'components/JobStatusOptions'

export default createListViewContainer({ actions, selectors: selectors.jobStatusOptions })(Component)
